import React from "react";
import PropTypes from "prop-types";
import { useArena } from "core/components/ArenaProvider";
import Stack from "@mui/material/Stack";
import TagList from "arena/components/TagList";
import ContentMetrics from "./ContentMetrics";
import ContentTitle from "./ContentTitle";
import ContentDescription from "./ContentDescription";
import ContentControls from "./ContentControls";
import Box from "@mui/material/Box";
import { useProxyPageOverride } from "arena/components/ProxyPage/ProxyPageOverrideContext";

const COLLECTION = "COLLECTION";
const STREAM = "STREAM";
const VIDEO = "VIDEO";
const CHANNEL = "CHANNEL";

export default function ContentBody({ content, getCurrentTime }) {
  const arena = useArena();
  const override = useProxyPageOverride();

  if (!content) return null;

  let title = override?.displayTitle || content.title;

  const shareData = {
    title: override?.displayTitle || content.title,
    // text: content.description,
    url: content.shareUrl,
  };

  const showControls =
    arena.isFavoritesEnabled ||
    arena.isLikesEnabled ||
    arena.isShareEnabled ||
    (content.type === COLLECTION && arena.isRegistrationEnabled);

  const showMetrics =
    (arena.displayContentMetadata ||
      (content.type === VIDEO && arena.showVideoViewersCount)) &&
    (content.type === VIDEO ||
      content.type === STREAM ||
      !!content.ageRestrictions);

  const description = override?.displayDescription
    ? override.displayDescription
    : content?.premiumDescription || content?.description;

  return (
    <Box
      sx={{ pt: { xs: 1.5, sm: 3 }, pb: { xs: 0, sm: 3 } }}
      id="content-body"
    >
      <Stack spacing={{ xs: 1.5, sm: 2 }}>
        {title && <ContentTitle>{title}</ContentTitle>}

        {showMetrics && <ContentMetrics content={content} arena={arena} />}

        {showControls && (
          <ContentControls
            contentId={content.id}
            isFavoritesEnabled={arena.isFavoritesEnabled}
            isLikesEnabled={arena.isLikesEnabled}
            isShareEnabled={arena.isShareEnabled}
            likes={content.likes}
            shareData={shareData}
            getCurrentTime={getCurrentTime}
            content={content}
          />
        )}

        {content.tags?.length > 0 && <TagList tags={content.tags} />}

        {description && <ContentDescription>{description}</ContentDescription>}
      </Stack>
    </Box>
  );
}

ContentBody.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    siteUrl: PropTypes.string.isRequired,
    shareUrl: PropTypes.string.isRequired,
    preview: PropTypes.string,
    publishAt: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    premiumDescription: PropTypes.string,
    ageRestrictions: PropTypes.number,
    type: PropTypes.oneOf([VIDEO, STREAM, COLLECTION, CHANNEL]).isRequired,
    // totalViews: PropTypes.number,
    // viewersOnline: PropTypes.number,
    premium: PropTypes.bool,
    viewerPurchase: PropTypes.object,
    likes: PropTypes.object,
    tags: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      })
    ),
  }),
  getCurrentTime: PropTypes.func,
};
